<template>

  <b-modal
    ref="modalCadastroEtapa"
    title="Cadastre uma nova etapa"
    size="sm"
    no-close-on-background
    :footer-class="'custom-footer-class'"
    :dialog-class="'alteracao-tamanho'"
    :modal-class="'center-modal'"
  >
    <div
      style="display: flex; flex-direction: column; align-items: center; gap: 2rem;"
    >
      <b-input
        v-model="novaEtapa.name"
        name="inputNovoFunil"
        placeholder="Nome da etapa..."
        autofocus
        style="width: 63% !important;"
      />
      <div style="margin-bottom: 1rem;">
        <p
          style="font-weight: 300; font-size: 12px; margin-bottom: 0 !important;"
        >
          Escolha uma cor:
        </p>
        <chrome v-model="novaEtapa.color" />
      </div>
    </div>

    <template #modal-footer>
      <b-button
        block
        size="md"
        class="btn-criar"
        variant="primary"
        @click="cadastrarNovaEtapa"
      >
        Criar
      </b-button>
    </template>
  </b-modal>
</template>
<style scoped>
</style>
<script>
import { Chrome } from 'vue-color'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'

const createNovaEtapaBase = () => ({
  name: '',
  color: '#283046',
  pipelineId: 0,
  description: '',
})

export default {
  name: 'ModalCadastroEtapa',

  components: {
    Chrome,
  },
  props: {
    funilSelecionado: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ['etapa-criada'],
  data() {
    return {
      novaEtapa: createNovaEtapaBase(),
    }
  },

  methods: {

    show() {
      this.$refs.modalCadastroEtapa.show()
    },
    hide() {
      this.$refs.modalCadastroEtapa.hide()
    },
    resetNovaEtapa() {
      this.novaEtapa = createNovaEtapaBase()
    },
    cadastrarNovaEtapa() {
      if (!this.novaEtapa.name) {
        this.$erro('Informe o nome para prosseguir.')
        return false
      }

      const pipelineId = this.funilSelecionado
      if (!pipelineId) {
        this.$erro('Selecione um funil antes de criar uma etapa.')
        return false
      }

      const payload = {
        ...this.novaEtapa,
        pipelineId,
        color: this.novaEtapa.color.hex || this.novaEtapa.color,
      }

      api.createPipelineStage(pipelineId, payload)
        .then(response => {
          const etapaCriada = response && response.data ? response.data : null
          this.$sucesso('Etapa cadastrada com sucesso.')
          this.$emit('etapa-criada', etapaCriada)
        })
        .catch(() => {
          this.$erro('Erro ao cadastrar etapa, tente novamente mais tarde.')
        })
        .finally(() => {
          this.resetNovaEtapa()
          this.hide()
        })

      return true
    },
  },
}
</script>
